import { useEffect, useState } from 'react';
import { defaultCoordinateSystemPreference, type CoordinateSystemPreference } from 'utils/coordinateSystemManager';

const useLocalCoordinateSystemSelector = (
  coordinateSystemPreference: CoordinateSystemPreference,
  setCoordinateSystemPreference: (nextPreference: Partial<CoordinateSystemPreference>) => void
) => {
  const isCustomMode = coordinateSystemPreference.mode === 'custom';
  const [customDraft, setCustomDraft] = useState<CoordinateSystemPreference>(
    isCustomMode
      ? { ...coordinateSystemPreference, mode: 'custom' }
      : { ...defaultCoordinateSystemPreference, mode: 'custom' }
  );

  useEffect(() => {
    if (isCustomMode) {
      setCustomDraft({ ...coordinateSystemPreference, mode: 'custom' });
    }
  }, [
    isCustomMode,
    coordinateSystemPreference.centerX,
    coordinateSystemPreference.centerY,
    coordinateSystemPreference.centerZ,
    coordinateSystemPreference.alpha,
  ]);

  const selectorValue = isCustomMode ? customDraft : { ...customDraft, mode: 'lv95' as const };

  const handleSelectorChange = (nextValue: CoordinateSystemPreference) => {
    if (nextValue.mode === 'custom') {
      const nextCustomDraft = { ...nextValue, mode: 'custom' as const };
      setCustomDraft(nextCustomDraft);
      setCoordinateSystemPreference(nextCustomDraft);
      return;
    }

    setCoordinateSystemPreference({ mode: 'lv95' });
  };

  return {
    selectorValue,
    handleSelectorChange,
  };
};

export default useLocalCoordinateSystemSelector;
